export const messages = {
  en: {
    labelManage: {
      queryTitle: 'Query Conditions',
      labelInfoTitle: 'Label Information',
      labelName: 'Label Name',
      labelCode: 'Label Code',
      domain: 'Domain',
      labelType: 'Label Type',
      createTime: 'Create Time',
      operation: 'Operation',
      addTitle: 'Add Label',
      editTitle: 'Edit Label',
      deleteTitle: 'Delete Confirmation',
      deleteConfirm: 'Are you sure to delete this label?',
      labelNamePlaceholder: 'Please enter label name',
      domainPlaceholder: 'Please select domain',
      publicDomain: 'Public Domain',
      otherDomain: 'Other Domain',
      customLabel: 'Custom',
      systemLabel: 'System Default',
      labelNameRequired: 'Label name is required',
      labelNameMaxLength: 'Label name cannot exceed 30 characters',
      domainRequired: 'Domain is required',
      labelIdRequired: 'Label ID is required'
    }
  },
  zh: {
    labelManage: {
      queryTitle: '查询条件',
      labelInfoTitle: '标签信息',
      labelName: '标签名称',
      labelCode: '标签编号',
      domain: '域',
      labelType: '标签类型',
      createTime: '创建时间',
      operation: '操作',
      addTitle: '添加标签',
      editTitle: '修改标签',
      deleteTitle: '删除确认',
      deleteConfirm: '确定删除该标签吗？',
      labelNamePlaceholder: '请输入标签名称',
      domainPlaceholder: '请选择域',
      publicDomain: '公共域',
      otherDomain: '其他',
      customLabel: '自定义',
      systemLabel: '系统默认',
      labelNameRequired: '标签名称不能为空',
      labelNameMaxLength: '标签名称不能超过30个字符',
      domainRequired: '域不能为空',
      labelIdRequired: '标签ID不能为空'
    }
  }
}